export interface GcsConfig {
  id: string;
  name: string;
  nameCode: string;
  baseUrl: string;
}

interface DerivedGcsUrls {
  httpBaseUrl: string;
  wsUrl: string;
}

export const deriveGcsUrls = (baseUrl: string): DerivedGcsUrls => {
  const parsed = new URL(baseUrl);
  const version = 'v1';

  const wsProtocol = parsed.protocol === 'https:' ? 'wss:' : 'ws:';

  return {
    httpBaseUrl: `${parsed.origin}/api/${version}`,
    wsUrl: `${wsProtocol}//${parsed.host}/dashboard/${version}/1`
  };
};
